import { Translate } from 'react-redux-i18n'
import { useLocation } from 'react-router'
import { Element } from '../../../common/html/element'
import { COMPONENTS } from '../../../routers/constants'

const getTitle = (location) => {
  const { summary, finance, score, segment } =
    COMPONENTS.portfolioInsights.components

  const porfolioTitle = {
    [summary.route]: 'portfolio.common.PORTFOLIO_SUMMARY',
    [finance.route]: 'portfolio.common.PORTFOLIO_BY_FINANCE',
    [score.route]: 'portfolio.common.PORTFOLIO_BY_SCORE',
    [segment.route]: 'portfolio.common.PORTFOLIO_BY_SEGMENT',
  }

  return porfolioTitle[location.pathname] || ' '
}

export const Title = () => {
  const location = useLocation()

  return (
    <Element
      className="fw600 textUppercase"
      style={{ color: '#0553A5', fontSize: 24 }}
    >
      <Translate value={getTitle(location)} />
    </Element>
  )
}
